import React from 'react';

const Dashboard = () => {
    return (
        <div className="container mx-auto px-4 py-8">
            <h1 className="text-3xl font-bold text-gray-900 mb-8">Dashboard</h1>
            
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                {/* Quick Stats */}
                <div className="bg-white rounded-lg shadow p-6">
                    <h3 className="text-lg font-semibold text-gray-700 mb-2">Total Clinics</h3>
                    <p className="text-3xl font-bold text-indigo-600">0</p>
                </div>
                
                <div className="bg-white rounded-lg shadow p-6">
                    <h3 className="text-lg font-semibold text-gray-700 mb-2">Active Clinics</h3>
                    <p className="text-3xl font-bold text-green-600">0</p>
                </div>
                
                <div className="bg-white rounded-lg shadow p-6">
                    <h3 className="text-lg font-semibold text-gray-700 mb-2">Pending Onboard</h3>
                    <p className="text-3xl font-bold text-yellow-600">0</p>
                </div>
            </div>

            <div className="mt-8 bg-white rounded-lg shadow">
                <div className="p-6">
                    <h2 className="text-xl font-semibold text-gray-900 mb-4">Recent Activity</h2>
                    <p className="text-gray-600">No recent activity to display.</p>
                </div>
            </div>
        </div>
    );
};

export default Dashboard; 